import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CategoriesService } from '../services/categories/categories.service';
import { categoryFilterOptions, CategoryFilterOption, CategoryFilterSelection } from '../utils/category-filter';

@Component({
  selector: 'app-category-filter', standalone: true, imports: [FormsModule],
  template: `
    <div class="min-w-0">
      <select aria-label="Filter by category or nested category" class="select select-bordered w-full min-w-0"
        [ngModel]="value" (ngModelChange)="select($event)" [disabled]="loading || !!error">
        <option [ngValue]="null">{{ loading ? 'Loading categories...' : 'All categories' }}</option>
        @for (option of options; track option.id) {
          <option [ngValue]="option.id">{{ option.label }}</option>
        }
      </select>
      @if (error) {
        <p class="text-xs text-error">Categories could not be loaded.
          <button type="button" class="underline" (click)="load()">Retry</button>
        </p>
      }
    </div>`,
})
export class CategoryFilterComponent implements OnInit {
  private readonly categories = inject(CategoriesService);
  @Input() value: number | null = null;
  @Output() selectionChange = new EventEmitter<CategoryFilterSelection>();
  options: CategoryFilterOption[] = [];
  loading = false;
  error = false;
  ngOnInit() { this.load(); }
  load() {
    this.loading = true;
    this.error = false;
    this.categories.getCategoryTreeAll(false).subscribe({
      next: tree => { this.options = categoryFilterOptions(tree); this.loading = false; },
      error: () => { this.error = true; this.loading = false; },
    });
  }
  select(id: number | null) {
    const option = this.options.find(item => item.id === id);
    this.selectionChange.emit(option ? { id, ids: [...option.ids] } : { id: null, ids: [] });
  }
}
